import Teachers from './teacher_module'
import Student from './student_module'
import Train from './trainers_module'
import Billing from './billing_module'
import http_service from "../classes/http";
import { bus } from '../other/bus'

let http = new http_service(bus);

export default {
  modules: {
    teacher: Teachers,
    student: Student,
    train: Train,
    billing: Billing
  },
  state: {
    user: '',
    trainers: '',
    current_trainer: '',
    current_stat: '',
    /** Платная платформа */
    prices: {
      subscribe: 1500,
      solo_student: 390,
      per_student: 250,
      students_in_subscribe: 5
    },
    /** Коэффицент за домашку*/
    hw_coefficient: 1.3,
    /** Цвета для рамок */
    colors: [
      '#be6fc6',
      '#58d87c',
      '#f8d937',
      '#ff4646',
      '#0080da',
      '#532664',
      '#fcca68',
      '#c9132c',
      '#ffb4d5',
      '#00b1f5',
      /* 'Lime',
       'Red',
       'DeepPink',
       'OrangeRed',
       'YellowGreen',
       'Cyan',
       'Yellow',
       'DeepSkyBlue',
       'Blue',
       'Magenta',
       'Crimson',
       'Gold',
       'Green',
       'Purple',*/
    ],

    react_minus: [
      'chtoby_stat_supergeroem_-.mp4',
      'tolko_vpered._ne_oglyadyvaysya_nazad.mp4',
      '01_dzhenias._idi_syuda-.mp4',
      '02_ne_boysya._ne_sem-.mp4',
      '03_te._kto_ne_razgadal_golovolomku-.mp4',
      '05_kristally_nuzhno_zasluzhit-.mp4',
      '01_-_ne_vremya_grustit.mp4',
      '02_-_ne_vremya_veshat_nos.mp4',
      '03_-_ne_spi._drug.mp4',
      '04_-_budte_ostrymi.mp4',
    ],
    react_plus: [
      'priznavaysya_.mp4',
      'aplodismenty_v_kruge.mp4',
      'aplodismenty.mp4',
      'uau._ty_-_supergeroy.mp4',
      '01_ya_ne_veryu_svoim_glazam!_eto_fantastika!_+.mp4',
      '02_ya_rada_+.mp4',
      '03_yohou!_+.mp4',
      '04_vot_eto_skorost!_+.mp4',
      '05_molodec_drug!_+.mp4',
      '06_vy_porazili_menya!_+.mp4',
      '05_-_vasha_snorovka_vozhd.mp4',
      '06_-_molodcy_(logiya).mp4',
      '07_-_my_molodcy!_a_teper_mozhno_i_pospat.mp4',
      '08_-_ura._srabotalo.mp4',
      '09_-_ura.mp4',
      '10_-_ura!_na_ostrove.mp4',
      '11_-_ya_veryu_v_vas.mp4',
    ],
  },
  mutations: {
    setUser(state, user) {
      this.state.user = user;
    },
    setTrainers(state, items) {
      this.state.trainers = items;
    },
    setCurrentTrainer(state, item) {
      this.state.current_trainer = item;
    },
    setCurrentStat(state, items) {
      this.state.current_stat = items;
    },
    shuffleColors(state) {
      state.colors = _.shuffle(state.colors);
    },
    changeUserScores(state, scores) {
      state.user.scores = state.user.scores + scores;
    },
    updateUserStatus(state, status) {
      state.user.status = status;
    },
    updateUserParam(state, val) {
      state.user[val.param] = val.value;
    }
  },
  actions: {
    async getCurrentTrainer(ctx, id) {
      let trainer = await http.post('onGetCurrentTrainer', { id }).then(res => res.data)
      ctx.commit('setCurrentTrainer', trainer);
    },
    async saveStats(ctx, arr) {
      let stat = await http.post('onSaveStats', { stat: arr }).then(res => res.data)
      // ctx.commit('setCurrentStat', stat);
    }
  },
  getters: {
    user(state) {
      return state.user
    },
    currentTrainer(state) {
      return state.current_trainer
    }
  }
}